export default class LanguageSwitch {
	constructor() {
		this.init();
	}

	init() {
		const languageSwitchButtons = document.querySelectorAll('.language__switch-button');
		const languageText = document.querySelector('.language__text > .inactive');
		let url = languageText.getAttribute('href');

		languageSwitchButtons.forEach((languageSwitchButton) => {
			if (url.indexOf('/en/') > 0) {
				languageSwitchButton.classList.add('switch-lang');
			} else {
				languageSwitchButton.classList.remove('switch-lang');
			}

			// Add click event listener to each .language__switch-button element
			languageSwitchButton.addEventListener('click', function () {
				if (languageSwitchButton.classList.contains('switch-lang')) {
					window.location = '/en';
				} else {
					window.location = '/';
				}
			});
		});
	}
}
